module.exports = __webpack_public_path__ + "img/c3.31231d2a.png";